// extracted by mini-css-extract-plugin
export default {"progressFields":"customerJourneyVisualizationProgress_progressFields__RMGEi","progressGoal":"customerJourneyVisualizationProgress_progressGoal__PS9V0"};